<template>
    <div class="train-index">
        <div class="college-bg prelative">
            <img src="@/assets/images/jm_no_bg.jpg" class="prelative dblock" />
			<!-- <div class="pabsolute lms tright">
				<a href="https://zjiet.cjnep.net/lms/web" target="_blank" class="lms-a dinline-block tcenter">
					<div class="fs24 mb5">学习端入口</div>
					<div class="fmt tupper">Learning Entrance</div>
				</a>
			</div> -->
        </div>
        <div class="htmldiv">
            <div class="scroll-news pt20 pb20 ofhidden">
            <div class="scrolldiv fl">
                <IndexSwiper v-if="info.tabloid" :bannerList="info.tabloid"
                    :options="{ id: 'swiper-train-news', showPage: true, navigation: true, loop: true, effect:  'coverflow' }"
                    :style="{ height: '400px' }">
                </IndexSwiper>
            </div>
            <div class="tab-news fl pl35">
                <div class="tabdiv borderb-gray">
                    <div class="fs20 fbold tc6 pb15 fl pl5">
                        <span @click="news_tab = 1" :class="news_tab == 1 ? 'active' : ''" class="cpointer before pb15 mr35">社会培训 </span>
                        <span @click="news_tab = 2" :class="news_tab == 2 ? 'active' : ''" class="cpointer before pb15 mr15">职业技能鉴定</span>
                    </div>
                    <a v-if="exam_url" :href="exam_url.value" target="_blank" class="zbtn border-m br8 fs16 fr trans3 mb10">
                        <span class="iconfont icon-kaoshifenxi vcenter"></span>
                        考试报名入口
                    </a>
                    <div class="clearn"></div>
                </div>
                <div class="pt10">
                    <News 
                        v-if="news_tab == 1"
                        id="p1" 
                        :class="'news-cur news-train anews-cur bashed cbr50 padate'" 
                        :newsList="info.social_training" 
                        :link="'train/news-detail'"
                    />
                    <News 
                        v-if="news_tab == 2"
                        id="p1" 
                        :class="'news-cur news-train anews-cur bashed cbr50 padate'" 
                        :newsList="info.occupational_skill_appraisal" 
                        :link="'train/news-detail'"
                    />

                    <div class="mt20">
                        <div @click="getMore" class="mcolor fr fs15 more prelative cpointer">更多内容>></div>
                    </div>

                </div>

            </div>
        </div>
        <a v-if="social_training_url" :href="social_training_url['value']" target="_blank" class="alink ofhidden dblock prelative">
            <img class="mw100 wd100 trans3" src="@/assets/images/jm_train.jpg" />
            <div class="p100 pabsolute dflex jc-center ai-center">
                <img class="img" src="@/assets/images/jm_train_01.png" />
            </div>
        </a>
        <div class="train-news-list ofhidden">
           
            <div class="wd25 fl pb20 pl10 pr10">
                <Stitle stitle="通知公告" :more="'/train/news/69'"  :class="'line'" />
                <News v-if="info.notice" class="train-news" type='notice' :newsList="info.notice"  :link="'train/news-detail'"/>
            </div>
            <div class="wd25 fl pb20 pl10 pr10">
                <Stitle stitle="培训资讯" :more="'/train/news/70'"  :class="'line'" />
                <News v-if="info.training_information" class="train-news" type='notice' :newsList="info.training_information"   :link="'train/news-detail'"/>
            </div>
            <div class="wd25 fl pb20 pl10 pr10">
                <Stitle stitle="鉴定资讯" :more="'/train/news/71'"  :class="'line'" />
                <News v-if="info.identification_information"  class="train-news" type='notice' :newsList="info.identification_information"  :link="'train/news-detail'"/>
            </div>
            <div class="wd25 fl pb20 pl10 pr10">
                <Stitle stitle="下载专区" :more="'/train/news/72'"  :class="'line'" />
                <News v-if="info.download_zone" class="train-news" type='notice' :newsList="info.download_zone"  :link="'train/news-detail'"/>
            </div>
        </div>
        </div>

    </div>
</template>
<script>
import IndexSwiper from '@/components/index/IndexSwiper'
import News from '@/components/common/News'
import Stitle from '@/components/common/Stitle'
export default {
    components: {
        IndexSwiper,
        News,
        Stitle
    },
    data() {
        return {
            info: {
                download_zone: [], //下载专区
                identification_information: [], //鉴定资讯
                training_information: [], //培训资讯
                notice: [],  //通知公告
                social_training: [], //社会培训 
                occupational_skill_appraisal: [], //职业技能鉴定
                tabloid: [],
            },
            exam_url: {},
            social_training_url: {},
            'news_tab': 1
        }
    },
    watch: {
        info: {
            deep: true
        }
    },
    created() {
        this.$request.get('non-academic-home', {}, res => {
            if (res.data.code == 200) {
                this.info = res.data.data
            }

        }, error => {
            console.log(error)
        })

        this.$request.get('no-academic-config', {}, res => {
            if (res.data.code == 200) {
                
                this.exam_url = res.data.data.exam_url
                this.social_training_url = res.data.data.social_training_url
            }

        }, error => {
            console.log(error)
        })
        
    },
    methods: {
        getMore(){
            var id = this.news_tab == 1 ? 67 : 68
            this.$router.push({
                path: `${this.$params.baseDir}train/news/${id}`
            })
        }
    }
}
</script>
<style scoped>
	.lms{
		left: 50%;
		bottom: 10px;
		transform: translateX(-50%);
		width: 1200px;
		

	}
	.lms-a{
		padding: 5px 40px;
		display: inline-block;
		background: var(--mcolor);
		color: #fff;
	}
	.lms-a:hover{
		  background: linear-gradient(to bottom, #609ae4, #3460d3);
	}
</style>

